// @flow

import memoize from 'memoize-weak';

import toLegacyCompatibleService from 'app/service/utils/toLegacyCompatibleService';

import type { Service } from 'app/service/types';

const combineToLegacyCompatibleServices = memoize(
  (
    publicServices: Array<Service>,
    privateServices: Array<Service>,
    includePrivateServices: boolean
  ) => {
    const consumerServices = includePrivateServices
      ? publicServices.concat(privateServices)
      : publicServices;

    const legacyCompatibleServices = consumerServices.map(
      toLegacyCompatibleService
    );
    return legacyCompatibleServices;
  }
);

export default combineToLegacyCompatibleServices;
